import type {
    ComposableOptionsBase,
    ContentBlockRendered,
    ContentBlockRenderedLinkedOptionsResponse,
    ContentBlocksByPlacementResponse
} from '~/types';
import {
    useCustomFetch
} from '~/composables';
import type { NitroFetchOptions } from 'nitropack';
import { isNil as lo_isNil } from 'es-toolkit';

export interface UseContentBlocksOptions extends ComposableOptionsBase {}
export function useContentBlocks(options: Partial<UseContentBlocksOptions> = {}) {
    const apiBasePath = '/v1/content/blocks';
    const $_fetch = useCustomFetch({ siteContext: options.siteContext });


    async function getContentBlock(uid: string, linkedPk?: MaybeRef<Nullable<number>>): Promise<ContentBlockRendered> {
        const url = `${apiBasePath}/${uid}/`;
        const pkValue = unref(linkedPk);

        const config: NitroFetchOptions<string> = {
            method: 'GET'
        };

        if (!lo_isNil(pkValue)) {
            config.query = { linked_pk: pkValue };
        }

        return await $_fetch<any>(url, config);
    }

    async function getContentBlockLinkedOptions(uid: string): Promise<ContentBlockRenderedLinkedOptionsResponse> {
        const url = `${apiBasePath}/${uid}/linked-options/`;

        const config: NitroFetchOptions<string> = {
            method: 'GET'
        };

        return await $_fetch<ContentBlockRenderedLinkedOptionsResponse>(url, config);
    }

    async function getContentBlocksByPlacement(placement: string): Promise<ContentBlocksByPlacementResponse> {
        const url = `/v1/content/placements/${placement}/blocks/`;

        const config: NitroFetchOptions<string> = {
            method: 'GET'
        };

        return await $_fetch<ContentBlocksByPlacementResponse>(url, config);
    }

    return {
        getContentBlock,
        getContentBlockLinkedOptions,
        getContentBlocksByPlacement
    };
}
